__turbopack_context__.v({
  "socialAnchor": "SocialIcon-module-scss-module__rt6c1q__socialAnchor",
});
